// extracted by mini-css-extract-plugin
export default {"pagination__bottom":"PaginationBottom_pagination__bottom__-mdXe","active":"PaginationBottom_active__9gjiM"};